module.exports = __webpack_public_path__ + "../resources/img/ic-delete.6f99e132.svg";